interface StoredRole {
  id: number;
  name: string;
  systemName?: string | null;
}

/** Get user roles from localStorage */
function getStoredRoles(): StoredRole[] {
  try {
    const roles = localStorage.getItem('userRoles');
    return roles ? JSON.parse(roles) : [];
  } catch {
    return [];
  }
}

/** Check if the current user has a specific system role */
export function hasSystemRole(systemName: string): boolean {
  return getStoredRoles().some((role) => role.systemName === systemName);
}

/** Check if the current user has any of the given system roles */
export function hasAnySystemRole(...systemNames: string[]): boolean {
  const roles = getStoredRoles();
  return systemNames.some((name) =>
    roles.some((role) => role.systemName === name),
  );
}

/** Check if the current user is an admin */
export function isAdmin(): boolean {
  return hasSystemRole('admin');
}
